/*
* 展示年月日 日分秒， 返回的值， 包含  年月日 时分秒 'YYYY-MM-DD HH:mm:ss'
*
* */

import React, {Component} from 'react';
import DatePickerClientS from '../DatePickerTimeZoneConversion';
require('./index.less');

// 发生订单的实时时间 页面不显示时分秒
export default class DatePickClientTime extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            format = ['YYYY-MM-DD HH:mm:ss', 'YYYYMMDD HH:mm:ss', 'YYYY.MM.DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss'],
            className,
            ...others
        } = this.props;
        return (
            <DatePickerClientS
                {...others}
                format={format}
                isClientTime={true}
                MultiTZ={true}
                dateInputPlaceholder='YYYYMMDD HH:mm:ss'
                className={`DatePickClientTime ${className}`}
            />
        );
    }
}
DatePickClientTime.defaultProps = {
    showTime: true,
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
